<template>
    <b-row class="mb-5">
        <b-col md="12">
          <div class="pt-2 pb-2 float-right">
            <a variant="light" style="margin-top:-100px!important; margin-right:10px!important;" class="btn-back btn-custom"></a>
            <!-- <b-button variant="info" style="margin-top:-88px!important;" class="mr-1 btn-download btn-custom" @click="doExportToExcel"><font-awesome-icon icon="download" style="font-size:15px!important;" /></b-button>
            <b-button variant="primary" style="margin-top:-88px!important;" class="btn-back btn-custom" @click="doModalAddRoadTax"><font-awesome-icon icon="plus"/></b-button> -->
          </div>
          <paginated-table ref="dataTable" :can-edit="false" :can-delete="false" :can-approve="false" :can-reject="false" :can-show="true" :can-show-route-path="'#/vehicle/road-tax-detail'" :can-edit-modal="true" :can-paid="false" v-on:editData="doEdit" :data-url="apiUrl.roadTax" :data-key="dataKey" :data-columns="columns">
          </paginated-table>
        </b-col>
      <add-road-tax-modal ref="addRoadTax" v-on:getRoadTaxBill="getRoadTaxBill"></add-road-tax-modal>
      <edit-road-tax-modal ref="editRoadTax" v-on:getRoadTaxBill="getRoadTaxBill"></edit-road-tax-modal>
    </b-row>
</template>
<script>
  import PaginatedTable from '@/components/PaginatedTable'
  import AddRoadTaxModal from './AddRoadTaxModal'
  import EditRoadTaxModal from './EditRoadTaxModal'
  export default {
    props: {
      vehicleUuid: {
        type: String,
        required: false
      }
    },
    components: {
      PaginatedTable,
      AddRoadTaxModal,
      EditRoadTaxModal
    },
    data: function() {
      var currentDate = new Date();
      var twoDigitFirstMonth= '01';
      var twoDigitFirstDate= '01';
      var createdDateTo = currentDate.getFullYear() + "-" + twoDigitFirstMonth + "-" + twoDigitFirstDate;
      
      var currentDate = new Date();
      var twoDigitLastMonth= '12';
      var twoDigitLastDate= '31';
      var createdDateBy = currentDate.getFullYear() + "-" + twoDigitLastMonth + "-" + twoDigitLastDate;

      return {
        dataKey: "vehicleBillInfo",
        isLoading: false,
        apiUrl: {
          vehicleRequest: window.AppConfig.apiUrl + 'vehicle-request',
          roadTax: window.AppConfig.apiUrl + 'vehicle-bill-info?vehicle_uuid=' + this.vehicleUuid + '&type=Road tax&start_due_date=' + createdDateTo + '&end_due_date=' + createdDateBy,
          exportRoadTax: window.AppConfig.apiUrl + 'export-vehicle-bill-general'
        },
        columns: [
          {
            label: 'Road Tax No.',
            key: 'billNumber',
            sortable: false
          },
          {
            label: 'Expired Date',
            key: 'typeDate',
            sortable: false
          },
          {
            key: 'amounts',
            label: 'Amount',
            sortable: false
          },
          {
            key: 'paidDateVehicle',
            label: 'Paid Date',
            sortable: false
          },
          {
            key: 'note',
            label: 'Note',
            sortable: false
          },
          {
            key: 'statusType',
            label: 'Status',
            sortable: false
          },
          {
            key: 'actions',
            label: '',
            sortable: false
          }
        ],
        vehicleRequestList: []
      }
    },
    mounted() {
      this.getRoadTaxBill()
    },
    methods: {
      getRoadTaxBill () {
        this.isLoading = true
        this.$refs.dataTable.getDataTable()
      },
      getDateTime (value) {
        if (value !== null) {
          return this.$moment(value).format('YYYY-MM-DD HH:mm A')
        } else {
          return '-'
        }
      },
      doExportToExcel () {
        let url = this.apiUrl.exportRoadTax + '?token=' + this.$store.getters['account/tokens'].access_token + '&type=Road Tax&vehicle_uuid=' + this.vehicleUuid
        
        window.open(url)
      },
      doModalAddRoadTax () {
        this.$refs.addRoadTax.showModal()
      },
      doEdit (row) {
        this.$refs.editRoadTax.showModal(row)
      },
      doShowModal (row) {
        this.$refs.editRoadTax.showModal(row)
      },
    }
  }
</script>